import { ProductEnum } from "./login";

export const VersaFields = [
  "Property Information",
  "Tax Exempt Categories",
  "Building",
  "Room Feature",
  "Room Location",
  "HouseKeeping Sections",
  "Department",
  "Category",
  "Tax Post Type",
  "Tax",
  "Post Type",
  "Room Type Maintenance",
  "Room Definition",
  "Guest Type",
  "Origins",
  //"Payment Method",
  // "Transportation",
  "Segment 1",
  "Segment 2",
];

export const GolfFields = [
  "Property Information",
  "Outlet Setup",
  "Courses",
  "Allocation Blocks",
  "Player Types",
  "Rate Types",
  "Player Type/Allocation Block",
  "Player Type/Rate Allocation",
  // "Tee Time Interval Setup",
  // commented out since we are not using these components now
  // "Tournament Format",
  // "Rain Check Setup",
  "Role Setup",
  "Category Groups",
  "Retail Categories",
  "Retail Sub Categories",
  "Retail Items Setup",
  "Taxes",
  "Discount Types",
  "Quick Sale Categories",
  "Vendor Types",
  "Discount Reasons",
  // "Rates Setup",
  "Vendor Setup",
  // "Tee Time Interval Templates",
  "Lesson Location",
  "Cancel Reasons",
];

export const SpaFields = [
  "Property Information",
  "Service Groups",
  "Outlet Setup",
  //"Role Setup",
  "Therapist Setup",
  "Service Locations",
  "Service Equipment",
  "Cancel Reasons",
  "Service Medical Conditions",
  // "No Show Reasons",
  "Break Types",
  "Lost Denied Reasons",
  "Log Types",
  "Guest Types",
  "Price Types",
  "Services",
  "Packages",
  "Category Groups",
  "Retail Categories",
  "Retail Sub Categories",
  "Retail Items Setup",
  "Category Linking",
  //"Payment Methods",
  "Taxes",
  "Vendor Types",
  "Vendor Setup",
  "Discount Reasons",
  "Discount Types",
  "Quick Sale Categories",
  "Add Ons",
  // "Item Numbers for Services",
  // "Item Numbers for Add Ons",
  // "Item Numbers for Day Packages",
];

/** Reserve Activities (productId 12) — same nav as dining for now. */
export const ReserveActivitiesFields = [
  "Property Information",
  "Outlet Setup",
  "Misc Items",
  "Property Questions",
  "Roles",
  "User Details",
  "Instructors",
  "User Permissions",
  "Rate Plan",
  "Service Charge",
  "Taxes",
  "Location",
  "Reservation Guest Notes",
  "Operation Hours",
  "Equipments/Add-ons",
  "Activities",
];

/** Reserve Dining (productId 13). */
export const ReserveDiningFields = [
  "Property Information",
  "Outlet Setup",
  "Misc Items",
  "Property Questions",
  "Roles",
  "User Details",
  "Instructors",
  "User Permissions",
  "Rate Plan",
  "Service Charge",
  "Taxes",
  "Tables",
  "Reservation Guest Notes",
  "Operation Hours",
];

export const RetailFields = [
  "Property Information",
  "Outlet Setup",
  "Category Groups",
  "Retail Categories",
  "Retail Sub Categories",
  "Category Linking",
  "Payment Methods",
  "Taxes",
  "Discount Types",
  "Discount Reasons",
  "Vendor Types",
  "Vendor Setup",
  "Retail Items",
  "Quick Sale Categories",
  "Role Setup",
  "User Setup",
];

export const SnCFields = [
  "Property Information",
  "Outlet Setup",
  "Users",
  "Market Segment",
  "Sales Manager",
  "Conference Service Manager",
  "Catering Manager",
  "Catering Managers",
  "Sales Calls Call Types",
  "Sales Calls Next Steps",
  "Cancel Codes",
  "Contact Type",
  "Arrival Types",
  "Reserved By Codes",
  "Cancellation Policy",
  "Potential Codes",
  "Denial Codes",
  "Task",
  "Distribution List",
  "Holidays and Hot Dates",
  "Function Room Setup",
  "Function Room Type Fee",
  "Functon Types",
  "Function Rooms Features",
  "Function Room",
  "Food Types",
  "Units of Measure",
  "Menu Items",
  "Setup Items",
  "Beverage Items",
  "Miscellaneous Items",
  "Audio Visual Items",
  "Room and Tax",
  "Incidentals",
  "Competitor Profile",
  "Payment Method",
  "Retail Setup",
  "Proforma Invoice Setup",
  "Comment Template",
  "Letters",
  "Week Configuration",
  "Fiscal Periods",
];

export enum GolfPropertyEnum {
  propertyInformation = "Property Information",
  courses = "Courses",
  allocationBlocks = "Allocation Blocks",
  playerTypes = "Player Types",
  rateTypes = "Rate Types",
  teeTimeIntervalSetup = "Tee Time Interval Setup",
  rateSetup = "Rates Setup",
  rainCheckSetup = "Rain Check Setup",
  roleSetup = "Role Setup",
  outletSetup = "Outlet Setup",
  categoryGroups = "Category Groups",
  retailCategories = "Retail Categories",
  retailSubCategories = "Retail Sub Categories",
  retailItems = "Retail Items Setup",
  taxes = "Taxes",
  discountTypes = "Discount Types",
  quickSaleCategories = "Quick Sale Categories",
  vendorTypes = "Vendor Types",
  discountReasons = "Discount Reasons",
  playerAllocationBlock = "Player Type/Allocation Block",
  vendorSetup = "Vendor Setup",
  teeTimeIntervalTemplates = "Tee Time Interval Templates",
  lessonLocation = "Lesson Location",
  cancelReasons = "Cancel Reasons",
  playerRateAllocation = "Player Type/Rate Allocation",
  questionnaire = "Questionnaire",
}

export enum SpaPropertyEnum {
  propertyInformation = "Property Information",
  serviceGroups = "Service Groups",
  outletSetup = "Outlet Setup",
  roleSetup = "Role Setup",
  therapistSetup = "Therapist Setup",
  serviceLocations = "Service Locations",
  serviceEquipment = "Service Equipment",
  cancelReasons = "Cancel Reasons",
  serviceMedicalConditions = "Service Medical Conditions",
  noShowReasons = "No Show Reasons",
  breakTypes = "Break Types",
  lostDeniedReasons = "Lost Denied Reasons",
  logTypes = "Log Types",
  guestTypes = "Guest Types",
  priceTypes = "Price Types",
  services = "Services",
  addOns = "Add Ons",
  dayPackages = "Packages",
  categoryGroups = "Category Groups",
  retailCategories = "Retail Categories",
  retailSubCategories = "Retail Sub Categories",
  categoryLinking = "Category Linking",
  paymentMethods = "Payment Methods",
  taxes = "Taxes",
  vendorTypes = "Vendor Types",
  vendorSetup = "Vendor Setup",
  discountReasons = "Discount Reasons",
  discountTypes = "Discount Types",
  quickSaleCategories = "Quick Sale Categories",
  itemNumbersForServices = "Item Numbers for Services",
  itemNumbersForAddOns = "Item Numbers for Add Ons",
  itemNumbersForDayPackages = "Item Numbers for Day Packages",
  retailItems = "Retail Items Setup",
  questionnaire = "Questionnaire",
}

export enum RetailPropertyEnum {
  propertyInformation = "Property Information",
  outletSetup = "Outlet Setup",
  categoryGroups = "Category Groups",
  retailCategories = "Retail Categories",
  retailSubCategories = "Retail Sub Categories",
  categoryLinking = "Category Linking",
  paymentMethods = "Payment Methods",
  taxes = "Taxes",
  discountTypes = "Discount Types",
  discountReasons = "Discount Reasons",
  vendorTypes = "Vendor Types",
  vendorSetup = "Vendor Setup",
  retailItems = "Retail Items",
  quickSaleCategories = "Quick Sale Categories",
  roleSetup = "Role Setup",
  userSetup = "User Setup",
  questionnaire = "Questionnaire",
}

export enum ReservePropertyEnum {
  propertyInformation = "Property Information",
  outletSetup = "Outlet Setup",
  miscItems = "Misc Items",
  propertyQuestions = "Property Questions",
  roles = "Roles",
  userDetails = "User Details",
  userPermissions = "User Permissions",
  ratePlan = "Rate Plan",
  serviceCharge = "Service Charge",
  taxes = "Taxes",
  location = "Location",
  tables = "Tables",
  instructors = "Instructors",
  reservationGuestNotes = "Reservation Guest Notes",
  operationHours = "Operation Hours",
  reservationSettings = "Reservation Settings",
  activities = "Activities",
  equipmentsAddOns = "Equipments/Add-ons",
}

export enum SnCPropertyEnum {
  propertyInformation = "Property Information",
  outletSetup = "Outlet Setup",
  users = "Users",
  marketSegment = "Market Segment",
  salesManager = "Sales Manager",
  conferenceServiceManager = "Conference Service Manager",
  cateringManager = "Catering Manager",
  cateringManagers = "Catering Managers",
  salesCallsCallTypes = "Sales Calls Call Types",
  salesCallsNextSteps = "Sales Calls Next Steps",
  cancelCodes = "Cancel Codes",
  contactType = "Contact Type",
  arrivalTypes = "Arrival Types",
  reservedByCodes = "Reserved By Codes",
  cancellationPolicy = "Cancellation Policy",
  potentialCodes = "Potential Codes",
  denialCodes = "Denial Codes",
  task = "Task",
  distributionList = "Distribution List",
  holidaysAndHotDates = "Holidays and Hot Dates",
  functionRoomSetup = "Function Room Setup",
  functionRoomTypeFee = "Function Room Type Fee",
  functonTypes = "Functon Types",
  functionRoomsFeatures = "Function Rooms Features",
  functionRoom = "Function Room",
  foodTypes = "Food Types",
  unitsOfMeasure = "Units of Measure",
  menuItems = "Menu Items",
  setupItems = "Setup Items",
  beverageItems = "Beverage Items",
  miscellaneousItems = "Miscellaneous Items",
  audioVisualItems = "Audio Visual Items",
  roomAndTax = "Room and Tax",
  incidentals = "Incidentals",
  competitorProfile = "Competitor Profile",
  paymentMethod = "Payment Method",
  retailSetup = "Retail Setup",
  proformaInvoiceSetup = "Proforma Invoice Setup",
  commentTemplate = "Comment Template",
  letters = "Letters",
  weekConfiguration = "Week Configuration",
  fiscalPeriods = "Fiscal Periods",
  questionnaire = "Questionnaire",
}

export enum RoomPropertyEnum {
  propertyInformation = "Property Information",
  buildingCodes = "Building",
  roomFeatures = "Room Feature",
  roomLocation = "Room Location",
  HousekeepingSections = "HouseKeeping Sections",
  roomTypeMaintainence = "Room Type Maintenance",
  roomDefinitions = "Room Definition",
  department = "Department",
  category = "Category",
  taxes = "Tax",
  taxExemptCategory = "Tax Exempt Categories",
  guestType = "Guest Type",
  postTypes = "Post Type",
  origin = "Origins",
  taxPostTypes = "Tax Post Type",
  PaymentMethods = "Payment Method",
  Transportation = "Transportation",
  Segment1 = "Segment 1",
  Segment2 = "Segment 2",
  questionnaire = "Questionnaire",
}

export const requiredFields = [
  RoomPropertyEnum.propertyInformation,
  RoomPropertyEnum.buildingCodes,
  RoomPropertyEnum.department,
  RoomPropertyEnum.taxPostTypes,
  RoomPropertyEnum.taxes,
  RoomPropertyEnum.postTypes,
  RoomPropertyEnum.roomTypeMaintainence,
  RoomPropertyEnum.roomDefinitions,
  RoomPropertyEnum.guestType,
  RoomPropertyEnum.PaymentMethods,
  GolfPropertyEnum.outletSetup,
  GolfPropertyEnum.courses,
  GolfPropertyEnum.allocationBlocks,
  GolfPropertyEnum.playerTypes,
  GolfPropertyEnum.rateTypes,
  GolfPropertyEnum.playerAllocationBlock,
  // GolfPropertyEnum.teeTimeIntervalSetup,
  GolfPropertyEnum.rainCheckSetup,
  GolfPropertyEnum.roleSetup,
  GolfPropertyEnum.categoryGroups,
  GolfPropertyEnum.retailCategories,
  GolfPropertyEnum.retailSubCategories,
  GolfPropertyEnum.taxes,
  GolfPropertyEnum.discountTypes,
  // GolfPropertyEnum.rateSetup,
  GolfPropertyEnum.questionnaire,
];

export const propertyInfromationRequiredFields = [
  "propertyName",
  "addressLine1",
  "city",
  "state",
  "country",
  "zipCode",
  "phoneNumber",
  "email",
];

export const pagesList = {
  [ProductEnum.GOLF]: GolfFields,
  [ProductEnum.SPA]: SpaFields,
  [ProductEnum.VERSA]: VersaFields,
  [ProductEnum.RETAIL]: RetailFields,
  [ProductEnum.SALES_AND_CATETING]: SnCFields,
  [ProductEnum.RESERVE_ACTIVITIES]: ReserveActivitiesFields,
  [ProductEnum.RESERVE_DINING]: ReserveDiningFields,
  [ProductEnum.TEST]: VersaFields,
};
